import FormTextField from '../../../../../main/components/Form/FormTextField/FormTextField';

const formFieldDataBHDecoupled = [
  {
    ComponentType: FormTextField,
    label: `Corporation Name`,
    name: 'corporationName',
    required: true,
    fullWidth: true,
    maxRows: 5,
    sx: {
      borderRadius: '40px',
    },
  },
  {
    ComponentType: FormTextField,
    label: `Sage ID`,
    name: 'sageID',
    required: true,
    fullWidth: true,
    maxRows: 5,
    sx: {
      borderRadius: '40px',
    },
    charLimit: 20,
  },
];

export default formFieldDataBHDecoupled;
